module.exports = __webpack_public_path__ + "static/img/13.b153a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/13.png
// module id = S3vA
// module chunks = 35